const nativeContactProperties = (t: any) => [
  {
    value: 'email', type: 'text', label: t('templateBuilder.formContactProperty.email'), fullLabel: t('templateBuilder.formContactProperty.fullLabel.email'),
  },
  {
    value: 'last_name', type: 'text', label: t('templateBuilder.formContactProperty.last_name'), fullLabel: t('templateBuilder.formContactProperty.fullLabel.last_name'),
  },
  {
    value: 'first_name', type: 'text', label: t('templateBuilder.formContactProperty.first_name'), fullLabel: t('templateBuilder.formContactProperty.fullLabel.first_name'),
  },
  {
    value: 'birthday', type: 'date', label: t('templateBuilder.formContactProperty.birthday'), fullLabel: t('templateBuilder.formContactProperty.fullLabel.birthday'),
  },
  {
    value: 'phone_number', type: 'text', label: t('templateBuilder.formContactProperty.phone_number'), fullLabel: t('templateBuilder.formContactProperty.fullLabel.phone_number'),
  },
  {
    value: 'consent_email', type: 'bool', label: t('templateBuilder.formContactProperty.consent_email'), fullLabel: t('templateBuilder.formContactProperty.fullLabel.consent_email'),
  },
  {
    value: 'consent_sms', type: 'bool', label: t('templateBuilder.formContactProperty.consent_sms'), fullLabel: t('templateBuilder.formContactProperty.fullLabel.consent_sms'),
  },
  {
    value: 'consent_whatsapp', type: 'bool', label: t('templateBuilder.formContactProperty.consent_whatsapp'), fullLabel: t('templateBuilder.formContactProperty.fullLabel.consent_whatsapp'),
  },
];

// Mapping des types de widgets vers leurs propriétés de contact autorisées
const widgetContactPropertiesMapping: Record<string, string[]> = {
  inputText: ['last_name', 'first_name'],
  inputEmail: ['email'],
  inputPhone: ['phone_number'],
  inputPassword: ['password'],
  inputDate: ['birthday'],
  inputCheckbox: [],
  consentCheckbox: ['consent_email', 'consent_sms', 'consent_whatsapp'],
  inputRadio: [],
  inputSelect: [],
  textarea: [],
};

const getNativeContactProperties = (t: any, typeWidget: string) => {
  if (typeWidget === '') {
    return nativeContactProperties(t);
  }

  const allowedProperties = widgetContactPropertiesMapping[typeWidget] || [];

  return nativeContactProperties(t).filter((item) => allowedProperties.includes(item.value));
};

export default getNativeContactProperties;
